import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'
import Numeral from 'numeral'
import ReactTableWrapper from 'components/ReactTableWrapper'
import { getEmptyImage } from '../../dashboard/_utils'
import { scrollTo } from '../dom/window'
import $ from '../../../_lib/jquery-3.2.1.min'
import { getProductURL } from '../selectors/defaultSelectors'
import { imageBaseUrl } from '../_utils'

export const ProductCell = ({ url_slug, image, title, splitPackSize }) => {
  return (
    <>
      <figure className="photo photo--center product-grid__photo">
        <a href={getProductURL(url_slug)} className="react-table__flex">
          {image ? (
            <img src={image?.includes(`${imageBaseUrl}`) ? image : `${imageBaseUrl + image}`} />
          ) : (
            <img src={getEmptyImage()} />
          )}
        </a>
      </figure>
      <div className="product-grid__content">
        {splitPackSize ? (
          <a href={getProductURL(url_slug)} className="product-grid__title" title={title + ' (' + splitPackSize + ')'}>
            {title + ' (' + splitPackSize + ' Pack' + ')'}
          </a>
        ) : (
          <a href={getProductURL(url_slug)} className="product-grid__title" title={title}>
            {title}
          </a>
        )}
      </div>
    </>
  )
}

const EvolutionRewardsCell = ({ url_slug, image, title, loyaltyPoints }) => {
  /**
   * For evolution rewards, the image aspect ratio should be 16:10
   */
  return (
    <>
      <figure className="photo photo--center product-grid__photo product-grid__photo--rewards">
        <a href={getProductURL(url_slug)} className="react-table__flex">
          {image ? <img src={image} /> : <img src={getEmptyImage()} />}
        </a>
        {loyaltyPoints && <span className="product-grid__points">{Numeral(loyaltyPoints).format('0,0')} points</span>}
      </figure>
      <div className="product-grid__content product-grid__content--rewards">
        <div className="product-grid__rewards-title">{title}</div>
        <a href={getProductURL(url_slug)} className="button button--border" title={title}>
          VIEW/REDEEM OFFER
        </a>
      </div>
    </>
  )
}

class ProductsList extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      wWidth: 0,
      wHeight: 0,
    }
  }
  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', () => this.updateWindowDimensions())
  }
  componentWillUnmount() {
    window.removeEventListener('resize', () => this.updateWindowDimensions())
  }
  updateWindowDimensions() {
    this.setState({
      wWidth: window.innerWidth,
      wHeight: window.innerHeight,
    })
  }
  getTableProps() {
    const { isEvolutionRewards } = this.props
    let gridClass = 'react-table react-table-grid'
    if (isEvolutionRewards) {
      gridClass += ' revolution-rewards'
    }

    const tableProps = {
      grid: {
        className: gridClass,
        columns: [
          {
            Header: () => null,
            Cell: (row) => {
              const { url_slug, image, title, loyaltyPoints, splitPackSize } = row.original

              if (isEvolutionRewards) {
                return (
                  <EvolutionRewardsCell url_slug={url_slug} image={image} title={title} loyaltyPoints={loyaltyPoints} />
                )
              }

              return <ProductCell url_slug={url_slug} image={image} title={title} splitPackSize={splitPackSize} />
            },
            headerClassName: 'hidden',
            accessor: 'id',
          },
        ],
        getTbodyProps: (state, row, col, instance) => {
          return {
            className: 'xs-1 sm-2 md-3 lg-3 xl-3',
          }
        },
        getTdProps: (state, row, col, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (e.target.tagName.toLowerCase() !== 'button') return

              if (handleOriginal) {
                handleOriginal()
              }
            },
          }
        },
        onPageChange: (pageIndex) => {
          const { changePagination, type } = this.props
          changePagination(pageIndex, type)
          this.scrollToTop()
        },
        SubComponent: false,
      },
    }
    if (typeof this.props.additionalProps != 'undefined') {
      const { additionalProps } = this.props
      if (typeof additionalProps.grid != 'undefined') {
        tableProps.grid = {
          ...tableProps.grid,
          ...additionalProps.grid,
        }
      }
    }

    return tableProps
  }
  scrollToTop() {
    const node = ReactDOM.findDOMNode(this)
    scrollTo($(node))
  }
  render() {
    const {
      isLoading,
      LS,
      products,
      requestProductsList,
      changeTableView,
      changePerPage,
      changeSort,
      tableView,
      perPage,
      sort,
      changeSearch,
      blockLocalSearch,
      activePage,
      startingIndex,
    } = this.props
    const tableProps = this.getTableProps()

    return (
      <React.Fragment>
        <ReactTableWrapper
          loading={isLoading}
          LS={LS}
          fetchParams={{
            // request: (params) => requestProductsList({ ...params, startingIndex: startingIndex}),
            request: (params) => requestProductsList({ startingIndex: startingIndex }),
          }}
          searchCallback={_.debounce((params) => changeSearch(params), 500)}
          blockLocalSearch={blockLocalSearch}
          initialSearchKeyword={typeof window.searchKeyword != 'undefined' ? window.searchKeyword : false}
          changeTableViewCallback={(params) => changeTableView(params)}
          changePerPageCallback={(params) => changePerPage(params)}
          changeSortCallback={(params) => changeSort(params)}
          tableView={tableView}
          perPage={perPage}
          sort={sort}
          data={products}
          categoryFilters={this.props.categoryFilters}
          pageIndex={activePage}
          reactTable={tableProps}
          hasSearch={true}
          hasDisplay
          // hasGridView
          hasFilters
          ref={(r) => (this.mainTableWrapper = r)}
        />
      </React.Fragment>
    )
  }
}

// default props
ProductsList.defaultProps = {
  perPage: 60,
  tableView: 'grid',
}
// validate props
ProductsList.propTypes = {}

export default ProductsList
